<template>
    <div>
        <breadCrumb
            :icon="'fa-upload'"
            :category="$t(`sideNav.navSalonReport`)"
            :subCategory="'Mall Integration'"
            :subSubCategory="''">
        </breadCrumb>
        <!-- <ul class="nav nav-tabs nav-tabs-clean px-3 px-sm-5 mt-3" role="tablist">
            <li class="nav-item" v-for="t in $i18n.messages[$i18n.locale].tab.reportSalesTabs" :key="t.id">
                <a class="nav-link bg-transparent fs-lg fw-400" :class="{'active': selectedTab == t.id}" @click="selectedTab = t.id">{{t.text}}</a>
            </li>
        </ul> -->

        <div class="px-1 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr pt-3 d-block">
                    <div class="row">
                        <div class="col-sm-12 col-md-4 mb-3">
                            <date-range-picker
                                class="w-100"
                                ref="picker"
                                v-model="dateRange"
                                :opens="'right'"
                                :autoApply="true"
                                :ranges="dateRanges"
                                :showDropdowns="true"
                                :always-show-calendars="false"
                                :locale-data="{ firstDay: 1, format: 'dd/mm/yyyy' }"
                                @showCustomRange="showCustomRangeCalendars = true"
                                @update="filterByDate"
                                :singleDatePicker="singleDatePicker"
                                :timePicker="timePicker"
                                >
                            </date-range-picker>
                        </div>
                    </div>
                    <div class="row pl-3 mb-3">
                        <div class="col">
                            <button type="button" class="btn btn-primary waves-effect waves-themed mr-2" @click="exportSales">Export</button>
                            <button type="button" class="btn btn-warning waves-effect waves-themed mr-2" @click="uploadSales">Upload</button>
                        </div>
                    </div>
                    <div class="row pl-3">
                        <div class="col">
                            <div>
                                {{ result }}
                            </div>
                        </div>
                    </div>
                    <br>
                    <div v-if="pre" class="row pl-3">
                        <div class="col">
                            <pre style="background: #ddd">
                                {{ pre }}
                            </pre>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import axios from 'axios'
import Swal from "sweetalert2";
import _ from 'lodash';
import BreadCrumb from './../Bread_Crumb'
import box from '../../../assets/js/dashboard/salonReport/salonReport'
import { formatPrice } from '../../../assets/js/dashboard/utilities'
import { handleSessionExpired, setSummaryBoxLabel } from '../../../assets/js/dashboard/dashboard'
import DateRangePicker from "vue2-daterange-picker";

let outletSetting = {
    'AtriaMall_CarezoneWellness': {
        timePicker: true,
    },
    'DCS_TheInfinityHairArt_ChinatownPoint': {
        timePicker: true,
    },
}

export default {
    name: "reportSales",
    components: {
        BreadCrumb,
        DateRangePicker,
    },
    data() {
        let host = 'https://mall.tunai.io/report/'
        // host = 'http://localhost:5001/report/'

        let dateRanges = {
            'Today': [ new moment(now).startOf('day').toDate(), new moment(now).startOf('day').toDate() ],
            'Yesterday': [ new moment(now).subtract(1, 'day').startOf('day').toDate(), new moment(now).subtract(1, 'day').startOf('day').toDate() ],
        }
        let singleDatePicker = true
        let timePicker = false

        let now = moment();
        let dateRange = {
            startDate: now.startOf("day").subtract(1, 'day').toDate(),
            endDate: now.endOf("day").subtract(1, 'day').toDate(),
        };

        // let urlSearchParams = new URLSearchParams(window.location.search)
        // let outlet = urlSearchParams.get('outlet')
        let segments = new URL(window.location.href).pathname.split('/')
        let outlet = segments.pop() || segments.pop()

        if (outletSetting[outlet]) {
            if (outletSetting[outlet]['timePicker']) {
                timePicker = true
            }
        }

        return {
            host,

            outlet,

            dateRanges,
            dateRange,
            singleDatePicker,
            timePicker,
            result: '',
            pre: '',
        }
    },
    watch: {
        selectedTab(value) {
        },
        "$i18n.locale"(val) {
        },
        '$route' (to, from){
            let segments = new URL(window.location.href).pathname.split('/')
            this.outlet = segments.pop() || segments.pop()

            if (outletSetting[this.outlet]) {
                if (outletSetting[this.outlet]['timePicker']) {
                    this.timePicker = true
                }
            }

            this.result = ''
            this.pre = ''
        }
    },
    methods: {
        filterByDate() {
        },
        exportSales() {
            this.result = ''
            this.pre = ''

            let $vm = this
            $vm.$axios({
                method: 'post',
                url: this.outlet,
                baseURL: this.host,
                headers: { token: $vm.$session.get('token') },
                data: {
                    export: 1,
                    start: new moment(this.dateRange.startDate).unix()
                },
            })
            .then((response) => {
                if (response.status == 200) {
                    this.result = 'Export success'

                    if (typeof response.data === 'object') {
                        try {
                            if (response.data.file && response.data.zreport) {
                                window.location.assign(this.host + this.outlet + '/upload/' + response.data.file)
                                setTimeout(() => {
                                    window.location.assign(this.host + this.outlet + '/upload/' + response.data.zreport)
                                }, 1000)
                                return
                            }

                            this.pre = JSON.stringify(response.data, null, 4)

                            return
                        } catch(e) {
                            console.log(e)
                        }
                    }

                    window.location.assign(this.host + this.outlet + '/upload/' + response.data)
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if (errData.error == $vm.$api.INVALID_TOKEN) {
                    handleSessionExpired();
                } else {
                    $vm.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
        uploadSales() {
            this.result = ''
            this.pre = ''

            let $vm = this
            $vm.$axios({
                method: 'post',
                url: this.outlet,
                baseURL: this.host,
                headers: { token: $vm.$session.get('token') },
                data: {
                    export: 0,
                    start: new moment(this.dateRange.startDate).unix()
                },
            })
            .then((response) => {
                if (response.status == 200) {
                    this.result = 'Upload success'

                    if (typeof response.data === 'object') {
                        try {
                            let temp = JSON.stringify(response.data, null, 4) || {}
                            this.pre = temp.message
                            return
                        } catch(e) {
                            console.log(e)
                        }
                    }

                    // window.location.assign(this.host + this.outlet + '/upload/' + response.data)
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if (errData.error == $vm.$api.INVALID_TOKEN) {
                    handleSessionExpired();
                } else {
                    $vm.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
    },
    mounted() {
    }
}
</script>
<style scoped>
.nav-link {
    cursor: pointer;
}

.modal-content {
    background: transparent;
    box-shadow: none;
}

.show {
    display: block;
}
</style>